export default __webpack_public_path__ + "static/media/lt.1d07a8b8.svg";